import WebRequest from './client/WebRequest.js';
export var GetNotificationSummary;
(function (GetNotificationSummary) {
    function api() {
        return WebRequest.GET('/doctor/notifications/summary');
    }
    GetNotificationSummary.api = api;
    function query(client) {
        return {
            queryKey: ['doctor-notification-summary'],
            queryFn: () => client.execute(api()),
            refetchInterval: 15000,
        };
    }
    GetNotificationSummary.query = query;
})(GetNotificationSummary || (GetNotificationSummary = {}));
export var ListNotifications;
(function (ListNotifications) {
    function api(params) {
        const query = new URLSearchParams();
        if (params.beforeDeliveryId) {
            query.set('beforeDeliveryId', String(params.beforeDeliveryId));
        }
        if (params.limit)
            query.set('limit', String(params.limit));
        const suffix = query.size > 0 ? `?${query.toString()}` : '';
        return WebRequest.GET(`/doctor/notifications${suffix}`);
    }
    ListNotifications.api = api;
    function execute(client, params) {
        return client.execute(api(params));
    }
    ListNotifications.execute = execute;
})(ListNotifications || (ListNotifications = {}));
export var MarkNotificationRead;
(function (MarkNotificationRead) {
    function api(deliveryId) {
        return WebRequest.POST('/doctor/notifications/read').body({ deliveryId });
    }
    MarkNotificationRead.api = api;
    function execute(client, deliveryId) {
        return client.executeEmpty(api(deliveryId));
    }
    MarkNotificationRead.execute = execute;
})(MarkNotificationRead || (MarkNotificationRead = {}));
export var ListNotificationChannels;
(function (ListNotificationChannels) {
    function api() {
        return WebRequest.GET('/admin/notifications/channels');
    }
    ListNotificationChannels.api = api;
})(ListNotificationChannels || (ListNotificationChannels = {}));
export var CreateAdminNotification;
(function (CreateAdminNotification) {
    function api(request) {
        return WebRequest.POST('/admin/notifications').body(request);
    }
    CreateAdminNotification.api = api;
    function execute(client, request) {
        return client.executeEmpty(api(request));
    }
    CreateAdminNotification.execute = execute;
})(CreateAdminNotification || (CreateAdminNotification = {}));
